import { SatisfactionFilter } from '../types';

export function transformFilterApiArg(
  filter: SatisfactionFilter,
): Omit<SatisfactionFilter, 'id' | 'is_valid'> {
  const { id: _id, is_valid: _isValid, ...rest } = filter;

  return rest;
}
